import React, { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import { contactLine, deletionDay } from './organization-deletion'
import { useDialogFocus } from './dialog-focus'
import '../sso-workspace/sso-workspace.scss'

// What a person sees when they pick an organization scheduled for deletion
// they can't restore here (scheduled-org member experience): what happened,
// until when, who can restore it, and whom to contact -- owners by full name,
// never an address (D2). No session, no read access (D3). ConfirmDialog's
// pattern: modal, Escape and the backdrop close it, focus starts on Close,
// Tab stays inside, and closing returns focus to the row that opened it.
export const ScheduledSheet = ({ organization, open, onClose }) => {
  const shown = !!(open && organization)
  const dialogRef = useRef(null)
  const closeRef = useRef(null)
  useDialogFocus(shown, dialogRef, closeRef)

  useEffect(() => {
    if (!open) return undefined
    const onKey = e => { if (e.key === 'Escape') { e.stopPropagation(); onClose() } }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open || !organization) return null
  const owner = organization.role === 'owner'

  return createPortal(
    <div className="sw-drawer justify-content-center align-items-center" onClick={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className="sw-dialog" ref={dialogRef} role="dialog" aria-modal="true" aria-labelledby="sched-sheet-title">
        <h2 className="h5" id="sched-sheet-title">{`${organization.name} is scheduled for deletion`}</h2>
        <p className="sw-hint">{`It will be permanently deleted on ${deletionDay(organization.purgeAfter)}. Until then it can't be opened.`}</p>
        {owner
          ? <p className="sw-hint">You can restore it from the admin panel when you're not viewing as someone else.</p>
          : <p className="sw-hint">Only an owner can restore it.</p>}
        {!owner && <p className="sw-hint">{contactLine(organization.ownerNames)}</p>}
        <div className="sw-dialog-actions">
          <button type="button" className="btn sw-btn" ref={closeRef} onClick={onClose}>Close</button>
        </div>
      </div>
    </div>,
    document.body
  )
}
